(() => {
  if (window.shoptimizerCustomerEvents) return;
  const purposes = ['analytics', 'marketing', 'sale_of_data'];
  const fields = {
    shoptimizer_contact_submitted: ['form_id'],
    shoptimizer_insights_search_started: [],
    shoptimizer_insights_report_viewed: ['report_type'],
    shoptimizer_insights_cta_clicked: ['target'],
    shoptimizer_tools_lead_submitted: [],
    shoptimizer_tool_downloaded: ['format']
  };
  function allowed() {
    try {
      const url = new URL(window.location.href), role = window.Shopify?.theme?.role;
      const path = url.pathname.replace(/^\/(?:de|en|fr|it|nl|es)(?:-[a-z]{2})?(?=\/|$)/i, '').replace(/\/$/, '');
      if (window.Shopify?.designMode === true || (role && role !== 'main') ||
          url.searchParams.has('preview_theme_id') || url.searchParams.has('preview_key') ||
          (path === '/pages/contact-us' && url.searchParams.has('view')) ||
          document.querySelector?.('script[data-insights-tracking]')?.dataset?.backendConnection === 'test') return false;
    } catch (_) { return false; }
    try { return window.shoptimizerConsent?.allowed(purposes) === true; } catch (_) { return false; }
  }

  // Keep only events captured with consent. A later opt-in never replays them.
  function publish(name, properties = {}, eventId) {
    if (!allowed() || !Object.hasOwn(fields, name)) return false;
    try { eventId ||= window.crypto.randomUUID(); } catch (_) { return false; }
    const data = {event_id: eventId};
    for (const field of fields[name]) data[field] = properties[field];
    let attempts = 0;
    let timer;
    let cancelled = false;
    function stop() {
      cancelled = true;
      clearTimeout(timer);
      document.removeEventListener('visitorConsentCollected', changed);
      window.removeEventListener('pagehide', stop);
    }
    function changed() { if (!allowed()) stop(); }
    function send() {
      if (cancelled || !allowed()) { stop(); return; }
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.publish !== 'function') {
        if (++attempts < 40) timer = setTimeout(send, 250);
        else stop();
        return;
      }
      stop();
      try {
        // A rejected provider promise must never break the customer action.
        Promise.resolve(analytics.publish(name, data)).catch(() => {});
      } catch (_) {}
    }
    document.addEventListener('visitorConsentCollected', changed);
    window.addEventListener('pagehide', stop);
    send();
    return true;
  }
  window.shoptimizerCustomerEvents = {allowed, publish};
})();
